exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".input-group-less-width{width:50%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/forecasted-commission/forecasted-commission.component.css"],"names":[],"mappings":"AAAA,wBACE,SAAW,CACZ","file":"forecasted-commission.component.css","sourcesContent":[".input-group-less-width {\n  width: 50%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/forecasted-commission/forecasted-commission.component.css
// module id = Zod0
// module chunks = 0